import { render, staticRenderFns } from "./FilesListTableFooter.vue?vue&type=template&id=5103b354&scoped=true"
import script from "./FilesListTableFooter.vue?vue&type=script&lang=ts"
export * from "./FilesListTableFooter.vue?vue&type=script&lang=ts"
import style0 from "./FilesListTableFooter.vue?vue&type=style&index=0&id=5103b354&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5103b354",
  null
  
)

export default component.exports